import { render, staticRenderFns } from "./OrderToastification.vue?vue&type=template&id=1910ef59&"
import script from "./OrderToastification.vue?vue&type=script&lang=js&"
export * from "./OrderToastification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports